import { Link, useLocation } from 'react-router-dom';
import { ROUTES } from '../helpers/contants';
import { navigation } from '../Utils/constantData';
import React, { useEffect, useRef } from 'react';
import { RootState, useAppSelector } from '../redux/store';
import { Avatar, Button, Menu, MenuItem } from '@mui/material';
import { AIT } from '../Utils/Localization';
import Images from '../Utils/images';
import CustomButton from '../Components/CustomButton';
import ChangeStudioModal from '../Components/ChangeStudioModal';
import { dataSetter } from '../Utils/helperFns';
import { useDispatch } from 'react-redux';
// import { setSelectedStudio } from '../redux/dashboardSlice'

import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import {
  removeBreadCrumbs,
  setAccordion,
  setCommonMenu,
  setSelectedStudio,
  setSelectedTab,
} from '../redux/commonSlice';
import { removeContactsList } from '../redux/ProductionSlice';

const scrollBottom = [
  '/company-management',
  '/roles',
  '/productions',
  '/requests',
];

const isNavigationItemActive = (
  item: any,
  currentHref: string,
  location: any,
) => {
  let isActive = item.path.includes(currentHref);
  const invoiceDetailFromRequests =
    currentHref === ROUTES.INVOICE_DETAIL &&
    new URLSearchParams(location.search).get('from') ===
      ROUTES.INVOICE_DETAIL_FROM_REQUESTS;

  if (invoiceDetailFromRequests && item.name === 'Invoices') {
    isActive = false;
  } else if (invoiceDetailFromRequests && item.name === 'Invoice Requests') {
    isActive = true;
  } else if (item.name == 'Return Requests') {
    if (location?.search.includes('type=return')) {
      isActive = true;
    }
  } else if (item.name === 'Orders') {
    if (
      location?.search.includes('type=list') &&
      !location?.search.includes('from=order')
    ) {
      isActive = true;
    }
  } else if (item.name === 'Order Requests') {
    if (
      location?.search.includes('type=request') &&
      !location?.search.includes('from=order')
    ) {
      isActive = true;
    }
  } else if (item.name === 'Vendor Requests') {
    if (
      location?.search.includes('type=vendor') &&
      !location?.search.includes('from=order')
    ) {
      isActive = true;
    }
  }

  return isActive;
};

export default function SideNavigation() {
  const listRef: any = useRef(null);
  const locaiton: any = useLocation();
  const dispatch = useDispatch();
  function isHashUrl(url: any) {
    return url.includes('/#/');
  }
  const {
    chat: { chatMap },
  } = useAppSelector((state: RootState) => state);
  const { allStudiolist } = useAppSelector((state: RootState) => state.studio);
  const {
    selectedStudio,
    profileData,
    selectedEntity,
    menu,
    accordian,
    selectedEntityType,
    permissionsData,
    loggedInMemberType,
    accessDashboards,
    isRiskAnalystUser,
  } = useAppSelector((state: RootState) => state.common);

  const selectedValue = useRef<any>({});
  const currentHref = isHashUrl(window.location.href)
    ? window.location.hash.includes('?')
      ? `/${window.location.hash.split('?')[0].split('/')[1]}`
      : `/${window.location.hash.split('/')[1]}`
    : `/${window.location.pathname.split('/')[1]}`;

  useEffect(() => {
    if (scrollBottom.includes(currentHref)) {
      listRef.current.scrollTop = listRef.current.scrollHeight;
    }
  }, [currentHref]);
  // Tab-wise unread chat counts: [All, User, Vendor, Group]
  const unreadChats = useAppSelector(state => {
    const chats = state.chat.mainInbox;
    let unread: any = 0;
    for (let i = 0; i < chats.length; i++) {
      const chat = chats[i];
      if ((chat.noOfUnreadMessage || 0) > 0) {
        unread += 1; // All
      }
    }
    return unread;
  });
  // Get total unread chat count
  const totalUnread = useAppSelector(state =>
    state.chat.mainInbox.reduce(
      (sum, chat) => sum + (chat.noOfUnreadMessage || 0),
      0,
    ),
  );
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [openChangeStudoi, setOpenChangeStudio] =
    React.useState<boolean>(false);
  const open = Boolean(anchorEl);

  // const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
  //   setAnchorEl(event.currentTarget)
  // }
  const handleClose = () => {
    setAnchorEl(null);
  };

  // useEffect(() => {
  //   getAllStudiosList('?page=1&limit=12')
  // }, [])

  useEffect(() => {
    if (
      Object.keys(selectedEntity || {}).length === 0 &&
      Object.keys(selectedStudio || {}).length === 0 &&
      allStudiolist?.studios?.length
    ) {
      dispatch(setSelectedStudio(allStudiolist?.studios[0]));
    }
  }, [allStudiolist]);

  useEffect(() => {
    selectedValue.current = selectedEntity;
  }, [selectedEntity]);

  const closeMenu = () => {
    dispatch(setCommonMenu(false));
    dispatch(setAccordion(false));
    document.body.classList.remove('body-freeze');
  };

  const isLimitedAccess = isRiskAnalystUser;

  // Only these should be visible when limited access is true
  const LIMITED_MENU = ['My Document', 'Inbox', 'Risk Center'];

  return (
    <>
      <div className="navigation">
        <div className="productionImage">
          <img
            src={
              typeof selectedValue?.current?.image === 'string' &&
              selectedValue.current.image.trim() !== ''
                ? selectedValue.current.image ||
                  selectedValue.current?.fallbackImage ||
                  Images.VENDOR_PLACEHOLDER
                : typeof selectedValue?.current?.image === 'object' &&
                  selectedValue.current?.image?.imageUrl
                ? selectedValue.current?.image?.imageUrl ||
                  selectedValue.current?.fallbackImage
                : selectedValue.current?.fallbackImage ||
                  Images.VENDOR_PLACEHOLDER
            }
            alt="Production"
          />
          <div className="select_production_btn">
            <CustomButton
              id=""
              text={
                selectedValue?.current?.name
                  ? selectedValue?.current?.episodeNumber &&
                    selectedEntityType === 'episode'
                    ? `${
                        selectedValue?.current?.episodeNumber
                          ? selectedValue?.current?.episodeNumber + ' - '
                          : ''
                      }${selectedValue?.current?.name}`
                    : selectedValue?.current?.name
                  : selectedValue?.current?.address
                  ? selectedValue?.current?.address?.locationName
                  : 'Change Studio'
              }
              variant="contained"
              showIcon
              icon={Images.Arrow_Down_White}
              iconPosition="end"
              iconType="image"
              isMobileTextVisible={true}
              width="100%"
              onClick={() => setOpenChangeStudio(true)}
            />
          </div>
        </div>
        <div className="mobile_info">
          <Button
            id="basic-button"
            aria-controls={open ? 'basic-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
            // onClick={handleClick}
          >
            <div className="userDropdown">
              <Avatar
                className="avatar"
                alt={AIT().user}
                src={
                  profileData?.profilePicture
                    ? profileData.profilePicture
                    : Images.Image_Placegolder
                }
              />

              {/* <Avatar>H</Avatar> */}
              <div className="info">
                <h4>
                  {profileData?.firstName} {profileData?.lastName}
                </h4>
                <p>{profileData?.email}</p>
              </div>
              {/* {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />} */}
            </div>
          </Button>
          <Menu
            id="user-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              'aria-labelledby': 'user-button',
            }}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
          >
            <MenuItem
              onClick={() => {
                handleClose();
              }}
            >
              Profile
            </MenuItem>
            <MenuItem onClick={() => handleClose()}>My account</MenuItem>
            <MenuItem>Logout</MenuItem>
          </Menu>
        </div>
        <ul ref={listRef}>
          {navigation.map((values, index: number) => {
            // A newly signed-up user has no permission record yet
            // (permissionsData stays empty) — show every option instead of
            // hiding it, since we can't determine a restriction.
            const hasNoPermissionsData = !permissionsData?.length;

            const financePermissions =
              permissionsData?.[0]?.finance?.permissions;

            const documentViewPermissions =
              permissionsData?.[0]?.accessLevel === 'FULL'
                ? permissionsData?.[0]?.fullAccessModules?.allDocument?.view
                : permissionsData?.[0]?.accessLevel === 'LIMITED'
                ? permissionsData?.[0]?.limitedAccessModules?.documents?.view
                : permissionsData?.[0]?.restrictedAccessModules?.allDocument
                    ?.view;

            const hasFinanceAccess =
              financePermissions?.allFinances?.view ||
              financePermissions?.departmentFinances?.view ||
              financePermissions?.ownFinances?.view;

            const hasMyOrdersAccess =
              financePermissions?.allOrders?.view ||
              financePermissions?.departmentOrders?.view ||
              financePermissions?.ownOrders?.view;

            // ||( (
            //   permissionsData?.[0]?.fullAccessModules?.riskCentrePermission
            //     ?.view === true ||
            //   permissionsData?.[0]?.limitedAccessModules?.riskCentrePermission
            //     ?.view === true
            // ) &&  (permissionsData?.[0]?.fullAccessModules?.allDocument ||  permissionsData?.[0]?.limitedAccessModules?.documents)
            // ?.view === true))
            // 👉 If limited access is ON, hide everything except Inbox & Risk Center
            if (isLimitedAccess && !LIMITED_MENU.includes(values.name)) {
              return null;
            }
            if (
              values.name === 'Risk Center' &&
              !hasNoPermissionsData &&
              !(
                permissionsData?.[0]?.fullAccessModules?.riskCentrePermission
                  ?.view === true ||
                permissionsData?.[0]?.limitedAccessModules?.riskCentrePermission
                  ?.view === true ||
                permissionsData?.[0]?.restrictedAccessModules
                  ?.riskCentrePermission?.view === true
              ) &&
              loggedInMemberType !== 'OWNER'
            ) {
              return null;
            }
            if (
              values.name === 'Finance' &&
              !hasNoPermissionsData &&
              !hasFinanceAccess &&
              loggedInMemberType !== 'OWNER'
            ) {
              return null;
            }
            const canAccessStore =
              loggedInMemberType === 'OWNER' ||
              !permissionsData?.[0]?.hideStore;
            if (values.name === 'Store' && !canAccessStore) {
              return null;
            }

            // Hide My Orders
            if (
              values.name === 'Orders' &&
              !hasNoPermissionsData &&
              !hasMyOrdersAccess &&
              loggedInMemberType !== 'OWNER'
            ) {
              return null;
            }

            // Hide My Invoice
            if (
              values.name === 'Invoice' &&
              !hasNoPermissionsData &&
              !hasMyOrdersAccess &&
              loggedInMemberType !== 'OWNER'
            ) {
              return null;
            }

            // Hide Payments
            if (
              values.name === 'Payment History' &&
              !hasNoPermissionsData &&
              !hasMyOrdersAccess &&
              loggedInMemberType !== 'OWNER'
            ) {
              return null;
            }

            if (
              values.name === 'My Document' &&
              !hasNoPermissionsData &&
              // !isLimitedAccess && // Skip permission check for risk analyst users
              !documentViewPermissions &&
              loggedInMemberType !== 'OWNER'
            ) {
              return null;
            }
            return (
              <li key={index}>
                {values?.childs?.length ? (
                  <Accordion
                    className="sidebar-expand"
                    expanded={accordian === values.name}
                    onChange={() => {
                      const isExpanding = accordian !== values.name;
                      // setExpandedAccordion(isExpanding ? values.name : false);
                      // removeBreadCrumbs();
                      dispatch(setCommonMenu(true));
                      document.body.classList.add('body-freeze');
                      dispatch(setAccordion(isExpanding ? values.name : false));
                    }}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1-content"
                      id="panel1-header"
                      title={values?.name}
                      className={
                        values.path.includes(`${currentHref}`)
                          ? ' activeLink'
                          : ''
                      }
                    >
                      <p
                        className={
                          values.path.includes(`${currentHref}`)
                            ? 'acc-link '
                            : 'acc-link'
                        }
                      >
                        <img src={values.icon} alt="" role="presentation" />
                        <span className="nav-text">{values?.name}</span>
                      </p>
                    </AccordionSummary>
                    <AccordionDetails>
                      {values.childs?.map((item: any) => {
                        // console.log(item.path, currentHref);
                        const isActive = isNavigationItemActive(
                          item,
                          currentHref,
                          locaiton,
                        );

                        return (
                          <Link
                            to={item.path[0]}
                            key={item.name}
                            className={isActive ? `activeLink` : ''}
                            onClick={e => {
                              removeBreadCrumbs();
                              removeContactsList([]);
                              // e.stopPropagation()
                              // dispatch(setCommonMenu(!open))
                              // Check if screen width is <= 1024px (tablet and smaller)
                              if (window.innerWidth <= 1024) {
                                closeMenu();
                              }
                            }}
                            title={item?.name}
                          >
                            {item?.name}
                          </Link>
                        );
                      })}
                    </AccordionDetails>
                  </Accordion>
                ) : (
                  <Link
                    to={values.path[0]}
                    className={
                      values.path.includes(`${currentHref}`) ? `activeLink` : ''
                    }
                    aria-label={`Navigate to ${values.name} page`}
                    onClick={() => {
                      if (
                        values.path.includes('/risk') ||
                        values.path.includes('/')
                      ) {
                        dataSetter('selectedTab', JSON.stringify(0));
                        dispatch(setSelectedTab(0));
                      }
                      removeBreadCrumbs();
                      removeContactsList([]);
                      // Check if screen width is <= 1024px (tablet and smaller)
                      if (window.innerWidth <= 1024) {
                        closeMenu();
                      }
                    }}
                    title={values.name}
                  >
                    <img
                      src={
                        values.path.includes(`${currentHref}`)
                          ? values.icon_active
                          : values.icon
                      }
                      alt=""
                      role="presentation"
                    />
                    <div className="nav-text">
                      {values.name}
                      {/* Show tab-wise unread chat count badges on Chats icon */}
                    </div>
                    {values.name === 'Inbox' && unreadChats > 0 ? (
                      <div className="chatCount">{unreadChats}</div>
                    ) : null}
                  </Link>
                )}
              </li>
            );
          })}

          {/* <li>
            <Accordion className="sidebar-expand">
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1-content"
                id="panel1-header"
              >
                <p className="acc-link">
                  <img
                    src={Images.PRODUCTION_ACTIVE}
                    alt=""
                    role="presentation"
                  />
                  <span className="nav-text">Production</span>
                </p>
              </AccordionSummary>
              <AccordionDetails>
                <Link to={''}>My Production</Link>
                <Link to={''}>My Episode</Link>
                <Link to={''}>My Sets</Link>
                <Link to={''}>My Locations</Link>
              </AccordionDetails>
            </Accordion>
          </li> */}

          {/* <li>
            <Accordion className="sidebar-expand">
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1-content"
                id="panel1-header"
              >
                <p className="acc-link">
                  <img src={Images.Order_Icon} alt="" role="presentation" />
                  <span className="nav-text">Orders</span>
                </p>
              </AccordionSummary>
              <AccordionDetails>
                <Link to={''}>My orders</Link>
                <Link to={''}>Draft Orders</Link>
                <Link to={''}>Order Requests</Link>
              </AccordionDetails>
            </Accordion>
          </li>

          <li>
            <Accordion className="sidebar-expand">
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1-content"
                id="panel1-header"
              >
                <p className="acc-link">
                  <img src={Images.STORE_IC} alt="" role="presentation" />
                  <span className="nav-text">Store</span>
                </p>
              </AccordionSummary>
              <AccordionDetails>
                <Link to={''}>Store</Link>
                <Link to={''}>My favourite</Link>
              </AccordionDetails>
            </Accordion>
          </li>

          <li>
            <Accordion className="sidebar-expand">
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1-content"
                id="panel1-header"
              >
                <p className="acc-link">
                  <img src={Images.Security_Ic} alt="" role="presentation" />
                  <span className="nav-text">Security</span>
                </p>
              </AccordionSummary>
              <AccordionDetails>
                <Link to={''}>Security Center</Link>
                <Link to={''}>Security Personnel</Link>
              </AccordionDetails>
            </Accordion>
          </li>

          <li>
            <Accordion className="sidebar-expand">
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1-content"
                id="panel1-header"
              >
                <p className="acc-link">
                  <img src={Images.Safety_Ic} alt="" role="presentation" />
                  <span className="nav-text">Safety</span>
                </p>
              </AccordionSummary>
              <AccordionDetails>
                <Link to={''}>Safety Center</Link>
                <Link to={''}>Safety Personnel</Link>
              </AccordionDetails>
            </Accordion>
          </li> */}
        </ul>
        {openChangeStudoi && (
          <ChangeStudioModal
            open={openChangeStudoi}
            data={allStudiolist?.studios || []}
            handleClose={() => setOpenChangeStudio(false)}
          />
        )}
        {/* <ChangeDepartmentModal open/> */}
      </div>
    </>
  );
}
